import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, Package2, RefreshCcw } from 'lucide-react';

function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#fbfbfd] to-white pt-32 px-6">
      <div className="max-w-[980px] mx-auto text-center">
        {/* Animated Container */}
        <div className="mb-12">
          {/* Animated Package Icon */}
          <div className="relative inline-block">
            <div className="animate-bounce">
              <Package2 className="w-32 h-32 text-[#0171E3]" />
            </div>
            {/* Animated Circles */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
              <div className="animate-ping-slow absolute w-48 h-48 bg-[#0171E3]/5 rounded-full" />
              <div className="animate-ping-slow absolute w-36 h-36 bg-[#0171E3]/10 rounded-full delay-300" />
              <div className="animate-ping-slow absolute w-24 h-24 bg-[#0171E3]/20 rounded-full delay-500" />
            </div>
          </div>
        </div>

        {/* 404 Text */}
        <h1 className="text-8xl font-bold text-[#1d1d1f] mb-6 animate-fade-in">
          404
        </h1>
        
        {/* Message */}
        <h2 className="text-2xl md:text-3xl font-semibold text-[#1d1d1f] mb-4 animate-fade-in-delay-1">
          Упс! Кажется, посылка потерялась
        </h2>
        <p className="text-xl text-[#86868b] max-w-2xl mx-auto mb-12 animate-fade-in-delay-2">
          Страница, которую вы ищете, не найдена. Возможно, она была перемещена или удалена.
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 animate-fade-in-delay-3">
          <button
            onClick={() => navigate('/')}
            className="inline-flex items-center bg-[#0171E3] text-white px-8 py-4 rounded-full hover:bg-[#0156aa] transition-all font-medium text-lg group w-full sm:w-auto justify-center"
          >
            <Home className="w-5 h-5 mr-2" />
            На главную
          </button>
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center bg-[#f5f5f7] text-[#1d1d1f] px-8 py-4 rounded-full hover:bg-[#e5e5e7] transition-all font-medium text-lg group w-full sm:w-auto justify-center"
          >
            <RefreshCcw className="w-5 h-5 mr-2" />
            Вернуться назад
          </button>
        </div>
      </div>

      <style>{`
        @keyframes ping-slow {
          0% {
            transform: scale(0.2);
            opacity: 0.8;
          }
          80%, 100% {
            transform: scale(2);
            opacity: 0;
          }
        }

        .animate-ping-slow {
          animation: ping-slow 3s cubic-bezier(0, 0, 0.2, 1) infinite;
        }

        .animate-fade-in {
          opacity: 0;
          animation: fade-in 0.5s ease-out forwards;
        }

        .animate-fade-in-delay-1 {
          opacity: 0;
          animation: fade-in 0.5s ease-out 0.2s forwards;
        }

        .animate-fade-in-delay-2 {
          opacity: 0;
          animation: fade-in 0.5s ease-out 0.4s forwards;
        }

        .animate-fade-in-delay-3 {
          opacity: 0;
          animation: fade-in 0.5s ease-out 0.6s forwards;
        }

        @keyframes fade-in {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
      `}</style>
    </div>
  );
}

export default NotFound;